import { Component, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent {

  constructor(public dialogRef: MatDialogRef<DeleteComponent>) {}

  @HostListener('window:keyup.esc') onKeyUp() {
    this.closeDialog(false);
  }
  @HostListener('window:keyup.enter') onEnterUp() {
    this.closeDialog(true);
  }

  closeDialog(result: boolean): void {
    this.dialogRef.close(result);
  }
}
